import { render, staticRenderFns } from "./AdvisorChat.vue?vue&type=template&id=9b48a932&scoped=true"
import script from "./AdvisorChat.vue?vue&type=script&lang=js"
export * from "./AdvisorChat.vue?vue&type=script&lang=js"
import style0 from "./AdvisorChat.vue?vue&type=style&index=0&id=9b48a932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b48a932",
  null
  
)

export default component.exports